import { render, staticRenderFns } from "./FlashcardsMenu.vue?vue&type=template&id=751459ac&scoped=true"
import script from "./FlashcardsMenu.vue?vue&type=script&lang=js"
export * from "./FlashcardsMenu.vue?vue&type=script&lang=js"
import style0 from "./FlashcardsMenu.vue?vue&type=style&index=0&id=751459ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751459ac",
  null
  
)

export default component.exports